import React, { useEffect, useState } from "react";
import "./modify-user-balance.css";
import { ClipLoader } from "react-spinners";
import { showToast } from "../toasts/ToastNotification";
import { modifyUserBalanceForAdmin } from "../../api/user.api";

const ModifyUserBalanceModal = ({ userId, isOpen, onClose, message, title, onSuccess }) => {
  const [selectedOption, setSelectedOption] = useState("add");
  const [amount, setAmount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [reason, setReason] = useState("");

  useEffect(() => {
    if (isOpen) {
      setSelectedOption("add");
      setAmount(0);
      setReason("");
      setLoading(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleModifyBalance = async () => {
    setLoading(true);

    if (amount <= 0) {
      setLoading(false);
      showToast("Số tiền phải lớn hơn 0", "error");
      return;
    }

    if (reason.trim() === "") {
      setLoading(false);
      showToast("Vui lòng nhập nội dung", "error");
      return;
    }

    try {
      const res = await modifyUserBalanceForAdmin(userId, selectedOption, amount, reason);
      if (res.success) {
        showToast("Chỉnh sửa số dư thành công", "success");
        if (typeof onSuccess === "function") {
          await onSuccess();
        }
        onClose();
      }
    } catch (error) {
      showToast(error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mub-overlay" onClick={onClose} role="presentation">
      <div className="mub-content" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
        <h2 className="mub-title">{title || "Chỉnh sửa số dư"}</h2>
        <p className="mub-message">{message || "Điền thông tin để chỉnh sửa số dư người dùng."}</p>

        <label className="mub-field">
          <span>Loại chỉnh sửa</span>
          <select className="mub-select" value={selectedOption} onChange={(e) => setSelectedOption(e.target.value)}>
            <option value="add">Thêm số dư</option>
            <option value="sub">Trừ số dư</option>
          </select>
        </label>

        <label className="mub-field">
          <span>Số tiền</span>
          <input
            className="mub-input"
            type="text"
            value={amount ? amount.toLocaleString("vi-VN") : ""}
            placeholder="Nhập số tiền"
            onChange={(e) => setAmount(Number(e.target.value.replace(/\D/g, "")))}
          />
        </label>

        <label className="mub-field">
          <span>Nội dung</span>
          <input
            className="mub-input"
            type="text"
            value={reason}
            placeholder="Nhập nội dung"
            onChange={(e) => setReason(e.target.value)}
          />
        </label>

        <div className="mub-actions">
          <button disabled={loading} className="mub-btn mub-btn-ghost" onClick={onClose} type="button">
            Hủy
          </button>
          <button onClick={handleModifyBalance} disabled={loading} className="mub-btn mub-btn-primary" type="button">
            {loading ? <ClipLoader size={18} color="#fff" /> : "Xác nhận"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModifyUserBalanceModal;
